<template>
	<div>
		<div class="actDiv">
			<label>选择时间范围</label>
			<a-select  style="width:6.5rem;margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theMonth" @change="queryData">
				<a-select-option v-for="(item,index) in monthList" :key="item.value" :value="item.value">{{item.name}}</a-select-option>
			</a-select>
		</div>
		<ve-line :data="lineData" :setting="settings" :extend="chartExtend" :loading="loading" judge-width  height="500px" :data-empty="lineData.rows.length==0"/>
	</div>
</template>

<script>
	import "v-charts/lib/style.css";
	export default {
		props:[
			"theObj"
		],
		data(){
			var self = this;
			this.settings = {
			}
			return {
				theMonth:1,
				monthList:[{name:"近一个月",value:1},{name:"近两个月",value:2},{name:"近三个月",value:3}],
				loading:false,
				lineData:{
					columns:["抄表日期","抄表读数"],
					rows:[],
				},
				chartExtend:{
					series:{
						smooth:false,
					}
				},
			}
		},
		methods:{
			queryData:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_RECENT_HISTORY_URL);
				let param = {meterId:this.theObj.PID,month:this.theMonth};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.lineData.rows = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.queryData();
		}
	}
</script>

<style>
</style>
